import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Seo from "@/components/Seo";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import WhatWeDo from "@/components/WhatWeDo";
import WhoWeHelp from "@/components/WhoWeHelp";
import Rooms from "@/components/Rooms";
import WorkWithUs from "@/components/WorkWithUs";
import ContactHousing from "@/components/ContactHousing";
import Footer from "@/components/Footer";
import BlogPost from "@/pages/BlogPost";
import Admin from "@/pages/Admin";
import ReferralFlyer from "@/pages/ReferralFlyer";

const LandingPage = () => (
  <div className="min-h-screen bg-[#F7F7F9] text-[#222222]">
    <Seo />
    <Header />
    <main>
      <Hero />
      <WhatWeDo />
      <WhoWeHelp />
      <Rooms />
      <WorkWithUs />
      <ContactHousing />
    </main>
    <Footer />
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/referral" element={<ReferralFlyer />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
